import qs from 'qs'
import axios from 'axios'

let invalidToken = false
let directLogin = false

const clientFromWindow =
  window.location && window.location.hostname.includes('-')
    ? window.location.hostname.split('-')[1]
    : window.location.hostname

let clientKiwi = clientFromWindow && clientFromWindow.split('.')[0]

let base_url = `https://api.startkiwi.com/${clientKiwi}/`

if (clientKiwi === 'v2') {
  base_url = `https://api-release.startkiwi.com/dev`

  // base_url = `https://api-release.startkiwi.com/dev/`
} else if (clientKiwi == 'release') {
  base_url = `https://api-release.startkiwi.com/pollozone`
} else if (clientKiwi === 'localhost') {
  base_url = `http://localhost:8080/local/`
} else if (clientKiwi === 'wingsnob') {
  base_url = `https://api.startkiwi.com/the${clientKiwi}/`
} else if (clientKiwi === 'pollozone') {
  base_url = `https://pollozone-loadbalancer.startkiwi.com/pollozone/`
} else if (clientKiwi === 'trattoria') {
  base_url = `https://api.startkiwi.com/alfredotrattoria/`
}

export const clientBaseUrl = () => {
  return base_url
}

const AXIOS = axios.create({
  // baseURL: 'http://localhost:8080/local',
  baseURL: base_url,
  // baseURL: 'https://api2.startkiwi.com/valdrin/',

  params: {
    token: localStorage.getItem('token'),
  },

  validateStatus(status) {
    switch (true) {
      case status >= 200 && status < 300:
        return true
      case status == 401:
        invalidToken = true

        if (localStorage.getItem('token')) {
          localStorage.removeItem('token')
          localStorage.removeItem('user')
          window.location.href = `${this.baseURL}/auth/login`
        }
        break
      default:
        return false
    }
  },
  transformRequest: [
    (data, headers) => {
      if (data instanceof FormData) {
        return data
      }
      return qs.stringify(data)
    },
  ],

  responseType: 'json',
})

AXIOS.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem('token')
    if (token) request.headers.Authorization = `Bearer ${token}`
    return request
  },
  (error) => {
    return Promise.reject(error)
  }
)

AXIOS.interceptors.response.use((response) => {
  switch (response.status) {
    case 200:
      invalidToken = true
      return response.data
    case 401:
    default:
      return Promise.reject({ error: 'Something went wrong' })
  }
})
const params = {
  headers: {
    Pragma: 'no-cache',
  },
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get(url) {
    return AXIOS.get(url, params)
  },

  post(url, data) {
    return AXIOS.post(url, data)
  },

  request(data) {
    return AXIOS.request(data)
  },

  put(url, data) {
    return AXIOS.put(url, data)
  },

  patch(url, data) {
    return AXIOS.patch(url, data)
  },

  delete(url, data) {
    return AXIOS.delete(url, data)
  },

  deleteWithData(url, data) {
    return axios.delete(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data,
    })
  },

  updateToken(token) {
    AXIOS.defaults.params = token
  },
}
